module.exports = __webpack_public_path__ + "static/media/thumbs-down.02a920ce.svg";